export const isCheckColorWhite = (bannerColor: string) => {
  const WHITE_COLORS = ['#fff', '#ffffff', 'white'];
  return WHITE_COLORS.includes(bannerColor);
};
export const defaultJmsColor = '#056D61';

/** defaultJmsColor's channels, so the fallback below never has to re-parse. */
export const DEFAULT_JMS_COLOR_RGB = '5, 109, 97';

/**
 * '#056D61' -> '5, 109, 97'
 *
 * For rgba(var(--some-rgb), a) in CSS, where a hex can't be used: keyframes and gradient stops
 * need the channels separately. Accepts 3- or 6-digit hex, with or without the leading '#', and
 * falls back to defaultJmsColor's channels for anything unparseable — banner_color comes from a
 * user-facing colour picker, so it isn't guaranteed to be a hex.
 */
export const hexToRgbTriplet = (color: string): string => {
  const hex = (color || '').trim().replace(/^#/, '');
  const expanded = hex.length === 3
    ? hex.split('').map((char) => char + char).join('')
    : hex;

  if (!/^[0-9a-fA-F]{6}$/.test(expanded)) {
    return DEFAULT_JMS_COLOR_RGB;
  }

  const int = parseInt(expanded, 16);

  return `${(int >> 16) & 255}, ${(int >> 8) & 255}, ${int & 255}`;
};
